import { ASSETS, Chapter, GiantHeadline, Reveal } from "../presentation";

export default function S09QA() {
  return (
    <section id="qa" className="about-immersive theme-dark" data-testid="slide-qa">
      <div className="about-immersive-media" data-testid="qa-media">
        <img src={ASSETS.qaBackdrop} alt="On deck — Sunreef yacht" />
      </div>
      <div className="about-immersive-scrim" />
      <div className="about-immersive-grain" />

      <div className="about-immersive-inner">
        <div className="sec-topbar" style={{ marginBottom: 0 }}>
          <Chapter ch="08" label="questions & answers" testid="qa-chapter" />
          <span className="wordmark wordmark-sm">SUNREEF</span>
        </div>

        <div className="about-immersive-content">
          <Reveal><span className="eyebrow">.open discussion</span></Reveal>
          <GiantHeadline line1="Q&A" accentLine={1} testid="qa-giant" />
          <Reveal delay={2}>
            <p className="editorial" data-testid="qa-lede">
              Your <span className="gold">turn.</span>
            </p>
          </Reveal>
        </div>

        <div className="about-immersive-foot">
          <span className="about-caption about-caption-corner" aria-hidden="true"></span>
        </div>
      </div>
    </section>
  );
}
